<template>
    <div class="categ_block">
        <div class="panel-tag">
            {{__t('REST_FILTER_CATEG_INFO')}}
        </div>

        <div class="categ_list p-3">
            <categlist @change="set_active_categ" :categories="this.categories"></categlist>
        </div>
    </div>
</template>

<script>
import Categlist from "../../../../catalog/categories/list/categlist";
export default {
    name: "location_categories",
    components: {Categlist},
    props : {
        location : {
            type : Object
        }
    },

    data() {
        return {
            categories : [],
            is_load : false,
        }
    },

    created () {
        this.load_categories();
    },

    methods : {

        set_active_categ(categ) {

            let cur_ids = this.active_ids;
            let cur_state = categ.is_active;
            if(cur_state == true) {
                cur_ids.push(parseInt(categ.id));
            }

            else {
                cur_ids.splice(cur_ids.indexOf(parseInt(categ.id)),1);
            }
            this.active_ids = cur_ids;

        },

        async load_categories() {
            this.categories = [];
            this.is_load =true;

            await api.post('/internal/v1/catalog/categories/tree',{
                "org_id" : this.location.parent_id,
                "provider_filter" : this.location.provider
            }).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    let categories = data.data;
                    this.set_categories_attr(categories);
                    this.categories =  categories;
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        set_categories_attr(categories)
        {
            categories.map(item => {
                item.is_active = this.active_ids.includes(parseInt(item.id));
                if(item.hasOwnProperty("children")) {
                    this.set_categories_attr(item.children);
                }
            });
        }
    },

    computed : {
        active_ids : {
            get :function () {
                let res = [];
                if(this.location.hasOwnProperty("categs")) {
                    if (this.location.categs != undefined && this.location.categs != null) {
                        return this.location.categs;
                    }
                }
                return res;
            },
            set: function (val) {
                if(this.location.hasOwnProperty("categs")) {
                    this.location.categs = val;
                }
            }

        }
    },

}
</script>

<style scoped>

</style>
